import {
    AiWriterCueField,
    AiWriterDraftSnapshot,
    getAiWriterFieldCue,
} from "../../helpers/aiSessionNotes";

interface AiWriterFieldCueProps {
    field: AiWriterCueField;
    snapshot: AiWriterDraftSnapshot | null;
    value: unknown;
}

export default function AiWriterFieldCue({
    field,
    snapshot,
    value,
}: AiWriterFieldCueProps) {
    const cue = getAiWriterFieldCue(snapshot, field, value);
    if (!cue) return null;

    const needsInput = cue === "needs_input";
    let label = "AI generated";
    if (needsInput) label = "Needs your input";

    return (
        <div className="mt-1 flex flex-wrap items-center gap-1.5">
            <span
                aria-label={`AI draft status: ${label}`}
                className={[
                    "inline-flex w-fit rounded-full px-2 py-0.5",
                    "text-caption font-medium",
                    needsInput
                        ? "bg-[--color-warning-bg] text-[--color-warning-text]"
                        : "bg-[--color-info-bg] text-[--color-info-text]",
                ].join(" ")}
            >
                {label}
            </span>
        </div>
    );
}
